import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowRight } from 'lucide-react';
export function ClosingSection() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 md:py-20 px-4 md:px-6 text-center border-t border-[var(--border-subtle)] bg-[var(--bg-surface)]" data-id="element-47">
      <div className="max-w-[720px] mx-auto space-y-6 md:space-y-8" data-id="element-48">
        <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] leading-tight" data-id="element-49">
          You have two choices tonight:
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 text-left" data-id="element-50">
          <div className="bg-[var(--bg-card)] p-6 md:p-8 rounded-2xl border border-[var(--border-subtle)] shadow-sm" data-id="element-51">
            <h3 className="font-bold text-[var(--text-heading)] text-lg mb-3" data-id="element-52">
              Path A
            </h3>
            <p className="text-[var(--text-primary)] text-sm md:text-base leading-relaxed" data-id="element-53">
              Keep doing what you're doing. Keep fighting at the table, keep
              worrying about their health, and keep feeling that "mom-guilt"
              every time you open a box of processed nuggets.
            </p>
          </div>

          <div className="bg-[var(--accent-soft)] p-6 md:p-8 rounded-2xl border border-[var(--accent)]/30 shadow-sm relative overflow-hidden" data-id="element-54">
            <div className="absolute top-0 left-0 w-full h-1 bg-[var(--accent)]" data-id="element-55"></div>
            <h3 className="font-bold text-[var(--accent)] text-lg mb-3" data-id="element-56">
              Path B
            </h3>
            <p className="text-[var(--text-heading)] text-sm md:text-base leading-relaxed font-medium" data-id="element-57">
              Click the button below. Spend 15 minutes a day "hacking" textures.
              See your child smile at the table. Watch them try their first
              piece of fruit in years.
            </p>
          </div>
        </div>

        <div className="pt-6" data-id="element-58">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-2 px-8 md:px-12 py-4 md:py-5 bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white font-bold text-base md:text-lg rounded-xl shadow-lg uppercase tracking-wide w-full md:w-auto justify-center transition-colors" data-id="element-59">
            YES! I WANT SENSORY VICTORY
            <ArrowRight className="w-5 h-5 ml-2" data-id="element-60" />
          </motion.button>
        </div>
      </div>
    </section>;
}